export default "__VITE_ASSET__B5da9xeT__"